document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const root = select.closest('[data-product-root]');
  const price = root && root.querySelector('[data-price]');
  const button = root && root.querySelector('[data-add-button]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? button.dataset.availableLabel : button.dataset.soldoutLabel;
  }
});
